module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading) ? _c('loading') : _c('div', {
    staticClass: "component-school-groups includes-header"
  }, [_c('header', {
    staticClass: "page-header school-groups-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.school.name))]), (_vm.groups.length) ? _c('p', [_vm._v("Aan welke klassen geef je les?"), _c('br'), _vm._v(" Maak een nieuwe klas aan met de "), _c('strong', [_vm._v("(+)")]), _vm._v(" knop")]) : _c('p', [_vm._v("Er zijn nog geen klassen aangemaakt voor deze school. Maak een nieuwe klas aan met de "), _c('strong', [_vm._v("(+)")]), _vm._v(" knop")]), _c('hr')]), (_vm.groups.length) ? _c('ul', {
    staticClass: "school-groups"
  }, _vm._l((_vm.groups), function(group) {
    return _c('li', {
      key: group.id,
      staticClass: "school-groups__item",
      on: {
        "click": function($event) {
          _vm.addGroup(group, $event)
        }
      }
    }, [_c('h2', {
      staticClass: "group-name",
      class: {
        active: _vm.isTeachingGroup(group)
      }
    }, [_vm._v(_vm._s(group.name))])])
  })) : _vm._e(), _c('a', {
    staticClass: "button-rounded button-create button-create-group",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createGroup($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--add"
  }), _vm._v("Nieuwe klas")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f61024","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/School.vue
// module id = 5hKk
// module chunks = 0 1